import { memo, useCallback, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import SelectListItem, {
  ListItem,
} from "@coworker/apprestructured/src/task-management/components/SelectListItem/SelectListItem";

const items: ListItem[] = [
  {
    label: "Item 1",
    value: "item1",
  },
  {
    label: "Item 2",
    value: "item2",
  },
  {
    label: "Item 3",
    value: "item3",
  },
  {
    label: "Item 4",
    value: "item4",
  },
];

function SelectItemDemo() {
  const [item, setItem] = useState<ListItem | null>(null);
  const [title, setTitle] = useState<string>("Title");

  const handleConfirmClick = useCallback((newItem: ListItem | null) => {
    setItem(newItem);
  }, []);

  return (
    <Demo>
      <Name>SelectListItem</Name>
      <Highlight>
        <FixaListView id="SelectItem" size="small">
          <SelectListItem
            title={title}
            selectedItem={item ?? null}
            items={items}
            onConfirmClick={handleConfirmClick}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaInputField
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
      </Actions>
    </Demo>
  );
}

export default memo(SelectItemDemo);
